import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { PoMultiselectComponent, PoMultiselectOption } from '@po-ui/ng-components';

import { TaskItem } from '../taskcommon/taskcommon.class';
import { TaskInputService } from './taskinput.service';
import { TaskInput } from './taskinput';
import { TaskInputItem } from './taskinputitem';
import { CostGroupFilterService } from './costgroupfilter.service';
import { Project } from 'src/app/Context/contextapplication/models/project';
import { InputItem } from 'src/app/Input/inputcommon/inputcommon.class';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-task-input',
    templateUrl: './taskinput.component.html',
    styleUrls: ['./taskinput.component.css'],
    standalone: false
})

export class TaskInputComponent extends PageBase implements OnInit, OnChanges {

  @Input() taskitem: TaskItem;
  taskInput = new TaskInput();

  itemsInputs: Array<InputItem>;

  temporaryContext: Project;
  placeholder: string;
  option: PoMultiselectOption;
  optionsMultiSelect: Array<PoMultiselectOption>;
  optionsSelected: Array<string>;
  hasFilterCostGroup = false;
  IsHideLoadingVejaMais: boolean;
  IsHideLoadingContainer: boolean;

  @ViewChild('costgroupmultiselect') costgroupmultiselect: PoMultiselectComponent;

  constructor(private taskInputService: TaskInputService,
              private costGroupService: CostGroupFilterService,
              public contextApplicationn: ContextApplication,
              public objInjector: Injector)
  {
    super(objInjector);
  }

  ngOnInit(): void {
   super.ngOnInit();
   this.restore();
   this.placeholder = this.literalsCp?.strPlaceHolderMultiSelectTaskInput;
   this.itemsInputs = [];
  }

  onReceiveLiterals(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.taskitem && !changes.taskitem.firstChange) {
      this.IsHideLoadingVejaMais = false;
      this.IsHideLoadingContainer = false;
      this.GetTaskInputItens();
      this.ValidateContextCostGroupOptions();
      this.costgroupmultiselect?.updateSelectedOptions([]);
    }
  }

  private GetTaskInputItens() {
    this.resetItems();
    this.taskInputService.ResetPages();
    this.GetTaskInput();
  }

  private ValidateContextCostGroupOptions() {
    if(this.temporaryContext.projectId != this.taskitem.projectid || this.temporaryContext.companyId != this.taskitem.companyid) {
        this.costGroupService.GetCostGroupOptions().then(
          result => {
            this.optionsMultiSelect = [];
            this.optionsMultiSelect = [...this.optionsMultiSelect, ...result];
          }
        );
    }
    else {
      this.optionsSelected = [];
    }

    this.temporaryContext.projectId = this.taskitem.projectid;
    this.temporaryContext.companyId = this.taskitem.companyid;
  }


  private GetTaskInput() {
    this.taskInputService.GetInfoTaskInput(this.taskitem).then(
      result => {
        this.IsHideLoadingContainer = true;
        this.taskInput = result;
        this.RefreshListInputs();
        this.IsHideLoadingVejaMais = true;
      }
    );
  }

  load() {
    this.IsHideLoadingVejaMais = false;
    if (this.hasFilterCostGroup) {
        this.taskInputService.GetInfoTaskInputWithCostGroup(this.taskitem, this.optionsSelected).then(
          result => {
            this.taskInput.hasNext = result?.hasNext;
            this.taskInput.total = result?.total;
            this.taskInput.items = this.taskInput.items.concat(result?.items);
            this.ConcatenateListInputs(result?.items);
            this.IsHideLoadingVejaMais = true;
          }
        );
    }
    else {
        this.taskInputService.GetInfoTaskInput(this.taskitem).then(
          result => {
            this.taskInput.hasNext = result?.hasNext;
            this.taskInput.total = result?.total;
            this.taskInput.items = this.taskInput.items.concat(result?.items);
            this.ConcatenateListInputs(result?.items);
            this.IsHideLoadingVejaMais = true;
          }
        );
    }
  }

  CostGroupChange(){
    this.IsHideLoadingVejaMais = false;
    this.IsHideLoadingContainer = false;
    if (this.optionsSelected.length > 0) {
      this.hasFilterCostGroup = true;
      this.resetItems();
      this.taskInputService.ResetPages();
      this.taskInputService.GetInfoTaskInputWithCostGroup(this.taskitem, this.optionsSelected).then(
        result => {
          this.taskInput = result;
          this.RefreshListInputs();
          this.IsHideLoadingVejaMais = true;
          this.IsHideLoadingContainer = true;
        }
      );
    }
    else {
      this.hasFilterCostGroup = false;
      this.resetItems();
      this.taskInputService.ResetPages();
      this.GetTaskInput();
    }
  }

  restore() {
    this.resetItems();
    this.option = { label: undefined, value: undefined };
    this.optionsMultiSelect = [];
    this.optionsSelected = [];
    this.temporaryContext = new Project();
  }

  resetItems() {
    this.taskInput.items = new Array<TaskInputItem>();
  }

  private RefreshListInputs() {
    this.itemsInputs = [];
    this.taskInput?.items.forEach(element => {
      this.itemsInputs.push(this.CreateInputItem(element));
    });
  }

  private ConcatenateListInputs(taskInputItens: TaskInputItem[]) {
    taskInputItens.forEach(x => this.itemsInputs = this.itemsInputs.concat(this.CreateInputItem(x)));
  }

  CreateInputItem(taskInput: TaskInputItem): InputItem{
    const inputInfo = new InputItem();
    inputInfo.companyid = taskInput.companyId;
    inputInfo.description = taskInput.inputDescription;
    inputInfo.inputCode = taskInput.inputCode;
    inputInfo.inputId = taskInput.inputId;
    inputInfo.projectid = taskInput.projectId;
    inputInfo.unitCode = taskInput.unitOfMeasure;
    inputInfo.taskid = this.taskitem.taskid;
    return inputInfo;
  }
}
